'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function () {
  return {
    select: {
      position: 'relative'
    },
    edit: {
      '&:hover': {
        cursor: 'pointer'
      },
      '& .field': {
        alignItems: 'center',
        '& input': {
          textOverflow: 'ellipsis'
        }
      },
      '& input': {
        cursor: 'pointer'
      },
      '& .rightIcon i, & .rightIcon svg': {
        width: '8px !important',
        height: '8px !important'
      }
    },
    menu: {
      position: 'absolute',
      width: '100%',
      maxWidth: 'inherit',
      marginTop: '-50px',
      zIndex: 99,
      maxHeight: 200 // TODO доработать открытие вверх

    }
  };
};